/* Auto-generated by generate-uns-dictionary.ts. Do not edit by hand. */
export const GeneratedObjectTypes = {
  /**
   * Maziva, olja, čistila, ki se porabijo in niso del izdelka.
   */
  "consumable-resource": "consumable-resource",
  /**
   * Merilno mesto za aktivno/jalovo energijo in moč.
   */
  "energy-meter": "energy-meter",
  /**
   * Energija (elektrika, para, plin).
   */
  "energy-resource": "energy-resource",
  /**
   * Fizična oprema (stroji, peči, senzorji). Uporablja se za spremljanje stanja, meritev in dogodkov.
   */
  "equipment": "equipment",
  /**
   * Tekočine in plini, ki niso energenti.
   */
  "fluid-resource": "fluid-resource",
  /**
   * Materialne enote (loti, serije, surovine, polizdelki). Za sledljivost, količine in premike.
   */
  "material": "material",
  /**
   * Osebje (operaterji, nadzorniki, tehnologi). Za prisotnost, naloge in status.
   */
  "personnel": "personnel",
  /**
   * Posamezen korak v procesu (npr. valjanje, hlajenje, analiza). Za faze ali aktivnosti procesa.
   */
  "process-segment": "process-segment",
  /**
   * Definicija izdelka, recepture, tehnični opisi. Za metapodatke izdelka in revizije.
   */
  "product-definition": "product-definition",
  /**
   * Kazalniki kakovosti izdelka (odstopanja, ocene, rezultati meritev).
   */
  "product-quality": "product-quality",
  /**
   * Status kateregakoli vira (material, osebje, oprema). Za razpoložljivost, okvare, izrabo.
   */
  "resource-status": "resource-status",
  /**
   * Utility viri (voda, zrak, dušik, stisnjeni plini).
   */
  "utility-resource": "utility-resource",
  /**
   * Definicija nalog ali delovnih tokov. Za planirane operacije in navodila.
   */
  "work-definition": "work-definition",
} as const;

export const GeneratedObjectTypeDescriptions: Record<keyof typeof GeneratedObjectTypes, string> = {
  "consumable-resource": "Maziva, olja, čistila, ki se porabijo in niso del izdelka.",
  "energy-meter": "Merilno mesto za aktivno/jalovo energijo in moč.",
  "energy-resource": "Energija (elektrika, para, plin).",
  "equipment": "Fizična oprema (stroji, peči, senzorji). Uporablja se za spremljanje stanja, meritev in dogodkov.",
  "fluid-resource": "Tekočine in plini, ki niso energenti.",
  "material": "Materialne enote (loti, serije, surovine, polizdelki). Za sledljivost, količine in premike.",
  "personnel": "Osebje (operaterji, nadzorniki, tehnologi). Za prisotnost, naloge in status.",
  "process-segment": "Posamezen korak v procesu (npr. valjanje, hlajenje, analiza). Za faze ali aktivnosti procesa.",
  "product-definition": "Definicija izdelka, recepture, tehnični opisi. Za metapodatke izdelka in revizije.",
  "product-quality": "Kazalniki kakovosti izdelka (odstopanja, ocene, rezultati meritev).",
  "resource-status": "Status kateregakoli vira (material, osebje, oprema). Za razpoložljivost, okvare, izrabo.",
  "utility-resource": "Utility viri (voda, zrak, dušik, stisnjeni plini).",
  "work-definition": "Definicija nalog ali delovnih tokov. Za planirane operacije in navodila.",
};

export type GeneratedObjectTypeName = keyof typeof GeneratedObjectTypes;

export function getGeneratedObjectTypeDescription(name: string): string | undefined {
  return (GeneratedObjectTypeDescriptions as Record<string, string | undefined>)[name];
}

export const GeneratedAttributes = {
  /**
   * Oddana delovna energija (izvoz).
   */
  "active-energy-delivered": "active-energy-delivered",
  /**
   * Prejeta delovna energija (uvoz).
   */
  "active-energy-received": "active-energy-received",
  /**
   * Alarmni signal.
   */
  "alarm": "alarm",
  /**
   * Dodeljeno osebi ali ekipi.
   */
  "assigned-to": "assigned-to",
  /**
   * Nivo pooblastil.
   */
  "authorization-level": "authorization-level",
  /**
   * Razpoložljivost vira.
   */
  "availability": "availability",
  /**
   * Številka serije (batch).
   */
  "batch-number": "batch-number",
  /**
   * Prevodnost.
   */
  "conductivity": "conductivity",
  /**
   * Poraba.
   */
  "consumption": "consumption",
  /**
   * Hitrost porabe.
   */
  "consumption-rate": "consumption-rate",
  /**
   * Strošek.
   */
  "cost": "cost",
  /**
   * Tok.
   */
  "current": "current",
  /**
   * Odstopanje od specifikacije.
   */
  "deviation": "deviation",
  /**
   * Zastoj/izpad.
   */
  "downtime": "downtime",
  /**
   * Trajanje faze ali naloge.
   */
  "duration": "duration",
  /**
   * Čas zaključka.
   */
  "end-time": "end-time",
  /**
   * Energija.
   */
  "energy": "energy",
  /**
   * Poraba energije.
   */
  "energy-consumption": "energy-consumption",
  /**
   * Koda napake.
   */
  "fault-code": "fault-code",
  /**
   * Pretok.
   */
  "flow": "flow",
  /**
   * Frekvenca.
   */
  "frequency": "frequency",
  /**
   * Trdota materiala.
   */
  "hardness": "hardness",
  /**
   * Rezultat pregleda.
   */
  "inspection-result": "inspection-result",
  /**
   * Povezava do navodil.
   */
  "instruction-url": "instruction-url",
  /**
   * Zadnje polnjenje.
   */
  "last-refill": "last-refill",
  /**
   * Nivo zaloge ali rezervoarja.
   */
  "level": "level",
  /**
   * Lokacija materiala ali opreme.
   */
  "location": "location",
  /**
   * Identifikator lota.
   */
  "lot-id": "lot-id",
  /**
   * Stanje vzdrževanja.
   */
  "maintenance-status": "maintenance-status",
  /**
   * Sestava materiala.
   */
  "material-composition": "material-composition",
  /**
   * Tip materiala.
   */
  "material-type": "material-type",
  /**
   * Število obratovalnih ur.
   */
  "operating-hours": "operating-hours",
  /**
   * Identifikator operaterja.
   */
  "operator-id": "operator-id",
  /**
   * Izhodna količina.
   */
  "output-quantity": "output-quantity",
  /**
   * Uspešno/neuspešno (pass/fail).
   */
  "pass-fail": "pass-fail",
  /**
   * pH vrednost.
   */
  "ph": "ph",
  /**
   * Planirani zaključek.
   */
  "planned-end": "planned-end",
  /**
   * Planirani začetek.
   */
  "planned-start": "planned-start",
  /**
   * Moč.
   */
  "power": "power",
  /**
   * Prisotnost osebja.
   */
  "presence": "presence",
  /**
   * Tlak.
   */
  "pressure": "pressure",
  /**
   * Koda izdelka.
   */
  "product-code": "product-code",
  /**
   * Količina materiala.
   */
  "quantity": "quantity",
  /**
   * Oddana jalova energija (izvoz).
   */
  "reactive-energy-delivered": "reactive-energy-delivered",
  /**
   * Prejeta jalova energija (uvoz).
   */
  "reactive-energy-received": "reactive-energy-received",
  /**
   * Potrebno dolivanje/dopolnitev.
   */
  "refill-required": "refill-required",
  /**
   * Revizija izdelka.
   */
  "revision": "revision",
  /**
   * Vloga osebja.
   */
  "role": "role",
  /**
   * Tehnične specifikacije.
   */
  "specification": "specification",
  /**
   * Hitrost delovanja.
   */
  "speed": "speed",
  /**
   * Čas začetka.
   */
  "start-time": "start-time",
  /**
   * Trenutno stanje vira ali opreme.
   */
  "status": "status",
  /**
   * Površinska napaka.
   */
  "surface-defect": "surface-defect",
  /**
   * Ciljni parametri izdelka ali procesa.
   */
  "target-parameters": "target-parameters",
  /**
   * Identifikator naloge.
   */
  "task-id": "task-id",
  /**
   * Seznam nalog.
   */
  "task-list": "task-list",
  /**
   * Temperatura vira/opreme.
   */
  "temperature": "temperature",
  /**
   * Natezna trdnost.
   */
  "tensile-strength": "tensile-strength",
  /**
   * Skupni pretok.
   */
  "total-flow": "total-flow",
  /**
   * Izraba vira.
   */
  "utilization": "utilization",
  /**
   * Zgodovina verzij.
   */
  "version-history": "version-history",
  /**
   * Merjena vibracija.
   */
  "vibration": "vibration",
  /**
   * Napetost.
   */
  "voltage": "voltage",
  /**
   * Identifikator delovnega naloga.
   */
  "work-order-id": "work-order-id",
} as const;

export const GeneratedAttributeDescriptions: Record<keyof typeof GeneratedAttributes, string> = {
  "active-energy-delivered": "Oddana delovna energija (izvoz).",
  "active-energy-received": "Prejeta delovna energija (uvoz).",
  "alarm": "Alarmni signal.",
  "assigned-to": "Dodeljeno osebi ali ekipi.",
  "authorization-level": "Nivo pooblastil.",
  "availability": "Razpoložljivost vira.",
  "batch-number": "Številka serije (batch).",
  "conductivity": "Prevodnost.",
  "consumption": "Poraba.",
  "consumption-rate": "Hitrost porabe.",
  "cost": "Strošek.",
  "current": "Tok.",
  "deviation": "Odstopanje od specifikacije.",
  "downtime": "Zastoj/izpad.",
  "duration": "Trajanje faze ali naloge.",
  "end-time": "Čas zaključka.",
  "energy": "Energija.",
  "energy-consumption": "Poraba energije.",
  "fault-code": "Koda napake.",
  "flow": "Pretok.",
  "frequency": "Frekvenca.",
  "hardness": "Trdota materiala.",
  "inspection-result": "Rezultat pregleda.",
  "instruction-url": "Povezava do navodil.",
  "last-refill": "Zadnje polnjenje.",
  "level": "Nivo zaloge ali rezervoarja.",
  "location": "Lokacija materiala ali opreme.",
  "lot-id": "Identifikator lota.",
  "maintenance-status": "Stanje vzdrževanja.",
  "material-composition": "Sestava materiala.",
  "material-type": "Tip materiala.",
  "operating-hours": "Število obratovalnih ur.",
  "operator-id": "Identifikator operaterja.",
  "output-quantity": "Izhodna količina.",
  "pass-fail": "Uspešno/neuspešno (pass/fail).",
  "ph": "pH vrednost.",
  "planned-end": "Planirani zaključek.",
  "planned-start": "Planirani začetek.",
  "power": "Moč.",
  "presence": "Prisotnost osebja.",
  "pressure": "Tlak.",
  "product-code": "Koda izdelka.",
  "quantity": "Količina materiala.",
  "reactive-energy-delivered": "Oddana jalova energija (izvoz).",
  "reactive-energy-received": "Prejeta jalova energija (uvoz).",
  "refill-required": "Potrebno dolivanje/dopolnitev.",
  "revision": "Revizija izdelka.",
  "role": "Vloga osebja.",
  "specification": "Tehnične specifikacije.",
  "speed": "Hitrost delovanja.",
  "start-time": "Čas začetka.",
  "status": "Trenutno stanje vira ali opreme.",
  "surface-defect": "Površinska napaka.",
  "target-parameters": "Ciljni parametri izdelka ali procesa.",
  "task-id": "Identifikator naloge.",
  "task-list": "Seznam nalog.",
  "temperature": "Temperatura vira/opreme.",
  "tensile-strength": "Natezna trdnost.",
  "total-flow": "Skupni pretok.",
  "utilization": "Izraba vira.",
  "version-history": "Zgodovina verzij.",
  "vibration": "Merjena vibracija.",
  "voltage": "Napetost.",
  "work-order-id": "Identifikator delovnega naloga.",
};

const GeneratedAttributesByTypeBase = {
  "consumable-resource": {
    /**
     * Nivo zaloge ali rezervoarja.
     */
    "level": "level",
    /**
     * Hitrost porabe.
     */
    "consumption-rate": "consumption-rate",
    /**
     * Potrebno dolivanje/dopolnitev.
     */
    "refill-required": "refill-required",
    /**
     * Zadnje polnjenje.
     */
    "last-refill": "last-refill",
    /**
     * Trenutno stanje vira ali opreme.
     */
    "status": "status",
  },
  "energy-meter": {
    /**
     * Moč.
     */
    "power": "power",
    /**
     * Oddana delovna energija (izvoz).
     */
    "active-energy-delivered": "active-energy-delivered",
    /**
     * Prejeta delovna energija (uvoz).
     */
    "active-energy-received": "active-energy-received",
    /**
     * Oddana jalova energija (izvoz).
     */
    "reactive-energy-delivered": "reactive-energy-delivered",
    /**
     * Prejeta jalova energija (uvoz).
     */
    "reactive-energy-received": "reactive-energy-received",
    /**
     * Napetost.
     */
    "voltage": "voltage",
    /**
     * Tok.
     */
    "current": "current",
    /**
     * Frekvenca.
     */
    "frequency": "frequency",
  },
  "energy-resource": {
    /**
     * Moč.
     */
    "power": "power",
    /**
     * Energija.
     */
    "energy": "energy",
    /**
     * Oddana delovna energija (izvoz).
     */
    "active-energy-delivered": "active-energy-delivered",
    /**
     * Prejeta delovna energija (uvoz).
     */
    "active-energy-received": "active-energy-received",
    /**
     * Oddana jalova energija (izvoz).
     */
    "reactive-energy-delivered": "reactive-energy-delivered",
    /**
     * Prejeta jalova energija (uvoz).
     */
    "reactive-energy-received": "reactive-energy-received",
    /**
     * Napetost.
     */
    "voltage": "voltage",
    /**
     * Tok.
     */
    "current": "current",
    /**
     * Frekvenca.
     */
    "frequency": "frequency",
    /**
     * Strošek.
     */
    "cost": "cost",
  },
  "equipment": {
    /**
     * Trenutno stanje vira ali opreme.
     */
    "status": "status",
    /**
     * Temperatura vira/opreme.
     */
    "temperature": "temperature",
    /**
     * Merjena vibracija.
     */
    "vibration": "vibration",
    /**
     * Število obratovalnih ur.
     */
    "operating-hours": "operating-hours",
    /**
     * Koda napake.
     */
    "fault-code": "fault-code",
    /**
     * Hitrost delovanja.
     */
    "speed": "speed",
    /**
     * Poraba energije.
     */
    "energy-consumption": "energy-consumption",
  },
  "fluid-resource": {
    /**
     * Pretok.
     */
    "flow": "flow",
    /**
     * Tlak.
     */
    "pressure": "pressure",
    /**
     * Temperatura vira/opreme.
     */
    "temperature": "temperature",
    /**
     * Skupni pretok.
     */
    "total-flow": "total-flow",
    /**
     * Prevodnost.
     */
    "conductivity": "conductivity",
    /**
     * pH vrednost.
     */
    "ph": "ph",
  },
  "material": {
    /**
     * Identifikator lota.
     */
    "lot-id": "lot-id",
    /**
     * Številka serije (batch).
     */
    "batch-number": "batch-number",
    /**
     * Tip materiala.
     */
    "material-type": "material-type",
    /**
     * Količina materiala.
     */
    "quantity": "quantity",
    /**
     * Lokacija materiala ali opreme.
     */
    "location": "location",
    /**
     * Trenutno stanje vira ali opreme.
     */
    "status": "status",
  },
  "personnel": {
    /**
     * Prisotnost osebja.
     */
    "presence": "presence",
    /**
     * Identifikator naloge.
     */
    "task-id": "task-id",
    /**
     * Vloga osebja.
     */
    "role": "role",
    /**
     * Trenutno stanje vira ali opreme.
     */
    "status": "status",
  },
  "process-segment": {
    /**
     * Čas začetka.
     */
    "start-time": "start-time",
    /**
     * Čas zaključka.
     */
    "end-time": "end-time",
    /**
     * Trajanje faze ali naloge.
     */
    "duration": "duration",
    /**
     * Trenutno stanje vira ali opreme.
     */
    "status": "status",
    /**
     * Izhodna količina.
     */
    "output-quantity": "output-quantity",
  },
  "product-definition": {
    /**
     * Koda izdelka.
     */
    "product-code": "product-code",
    /**
     * Revizija izdelka.
     */
    "revision": "revision",
    /**
     * Tehnične specifikacije.
     */
    "specification": "specification",
    /**
     * Ciljni parametri izdelka ali procesa.
     */
    "target-parameters": "target-parameters",
    /**
     * Sestava materiala.
     */
    "material-composition": "material-composition",
    /**
     * Zgodovina verzij.
     */
    "version-history": "version-history",
  },
  "product-quality": {
    /**
     * Rezultat pregleda.
     */
    "inspection-result": "inspection-result",
    /**
     * Odstopanje od specifikacije.
     */
    "deviation": "deviation",
    /**
     * Uspešno/neuspešno (pass/fail).
     */
    "pass-fail": "pass-fail",
    /**
     * Površinska napaka.
     */
    "surface-defect": "surface-defect",
    /**
     * Trdota materiala.
     */
    "hardness": "hardness",
    /**
     * Natezna trdnost.
     */
    "tensile-strength": "tensile-strength",
  },
  "resource-status": {
    /**
     * Razpoložljivost vira.
     */
    "availability": "availability",
    /**
     * Izraba vira.
     */
    "utilization": "utilization",
    /**
     * Zastoj/izpad.
     */
    "downtime": "downtime",
    /**
     * Trenutno stanje vira ali opreme.
     */
    "status": "status",
    /**
     * Stanje vzdrževanja.
     */
    "maintenance-status": "maintenance-status",
  },
  "utility-resource": {
    /**
     * Tlak.
     */
    "pressure": "pressure",
    /**
     * Pretok.
     */
    "flow": "flow",
    /**
     * Poraba.
     */
    "consumption": "consumption",
    /**
     * Trenutno stanje vira ali opreme.
     */
    "status": "status",
    /**
     * Alarmni signal.
     */
    "alarm": "alarm",
  },
  "work-definition": {
    /**
     * Identifikator delovnega naloga.
     */
    "work-order-id": "work-order-id",
    /**
     * Seznam nalog.
     */
    "task-list": "task-list",
    /**
     * Planirani začetek.
     */
    "planned-start": "planned-start",
    /**
     * Planirani zaključek.
     */
    "planned-end": "planned-end",
    /**
     * Dodeljeno osebi ali ekipi.
     */
    "assigned-to": "assigned-to",
    /**
     * Povezava do navodil.
     */
    "instruction-url": "instruction-url",
  },
} as const;

export const GeneratedAttributesByType = GeneratedAttributesByTypeBase;

export type GeneratedAttributeName = keyof typeof GeneratedAttributes;

export type GeneratedAttributesFor<T extends keyof typeof GeneratedAttributesByType> = keyof typeof GeneratedAttributesByType[T];

export function getGeneratedAttributeDescription(name: string): string | undefined {
  return (GeneratedAttributeDescriptions as Record<string, string | undefined>)[name];
}
